import { useEffect, useState, useContext } from 'react';
import { Row, Col } from 'reactstrap';
import FullLayout from '../layouts/FullLayout';
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { AlertContext } from "../utils/contexts/RoleContext";
import { fetchKYC, updateKYC, deleteKYC } from '../services/userServices';
import DeleteModal from '../components/DeleteModal';
import { FileIcon, defaultStyles } from 'react-file-icon';
import { downloadFile } from '../utils/utils';
import Pagination from "../components/Pagination";
import { decidePages } from "../../src/utils/utils";

// const Users = ({ setJwtToken }) => {
const KYCRequests = () => {

    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [copy, setCopy] = useState([]);
    const [requestStatus, setRequestStatus] = useState('');
    const [deleteId, setDeleteId] = useState(0);

     const [pages, setPages] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);

    const toast = useContext(AlertContext);


    //   const toast = useContext(AlertContext);
    useEffect(() => {
        fetchRequests(pageNumber);
    }, [requestStatus,pageNumber]);

    const fetchRequests = async (page) => {
       
        try {
          
            const pageCount = page != undefined ? page : 1;
            const response = await fetchKYC(pageCount);
            const responseData = response.data;
            if (response.status == 200) {
                setData(responseData.data || []);
                setCopy(responseData.data || []);

                setPages(Array.from({ length: responseData.totalPages }, (_, i) => i + 1));

            }
        } catch (e) {
            console.log("error", e)
        }
    }

    const updateRequest = async (id, status) => {
        try {
            const response = await updateKYC(id, status);
            const responseData = response.data;
            let theme = "success"
            if (response.status == 200) {
                fetchRequests();
            } else {
                theme = "danger"
            }
            toast.setToast(responseData.message, theme)
        } catch (e) {
            console.log("error", e)
        }
    }

    const deleteOneKYC = async () => {
        try {
            const response = await deleteKYC(deleteId);
            const responseData = response.data;
            let theme = "success"
            if (response.status == 200) {
                fetchRequests();
            } else {
                theme = "danger"
            }
            toast.setToast(responseData.message, theme)
        } catch (e) {
            console.log("error", e)
        }
    }

    // Handle status change in dropdown
    const handleStatusChange = (event) => {
        setRequestStatus(event.target.value);
        // fetchRequests(); // Fetch requests based on selected status
    };


    return (
        <FullLayout>
            <Row>

                <div className="panel_top_section">
                    <h1>KYC Requests</h1>
                    {/* <div className="grid_icons d-flex gap-3 align-items-center float-end">
                        <select aria-label="Default select example" class="form-select"
                            onChange={handleStatusChange}
                            value={requestStatus}
                        >
                            <option value={0}>Pending</option>
                            <option value={1}>Approved</option>
                            <option value={2}>Denied</option>

                        </select>
                    </div> */}
                </div>
                <Col>
                    {/* --------------------------------------------------------------------------------*/}
                    {/* Card-1*/}
                    {/* --------------------------------------------------------------------------------*/}
                    <div className="tab-content" id="pills-tabContent">

                        {/* list-tab */}
                        <div className="tab-pane fade show active" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                            <div className="row d-flex ">
                                <table>
                                    <tr className="list_head">
                                        <th>S No</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Documents</th>
                                        {/* <th>Status</th> */}
                                        <th>Actions</th>
                                    </tr>
                                    {/* crud */}
                                    {data.length > 0 ? (
                                        data.map((eachItem, index) => {
                                            return (
                                                <tr key={eachItem.id} className="list_detail">
                                                    <td>{index + 1}</td>
                                                    <td>{eachItem.user?.name}</td>
                                                    <td>{eachItem.user?.email}</td>
                                                    <td>
                                                        <div className="file-icons">
                                                            {JSON.parse(eachItem.files)?.map((item, index) => {
                                                                const splittedItem = item.originalname.split(".");
                                                                const ext = splittedItem[splittedItem.length - 1]
                                                                return (
                                                                    <div key={index} className="file-icon" onClick={() => downloadFile(item.filename)}>
                                                                        <FileIcon extension={ext} {...defaultStyles[ext]} />
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {eachItem.status == 0 ?
                                                            <span class="action" >
                                                                <button class="edit_btn"
                                                                    onClick={() => updateRequest(eachItem.id, 1)}
                                                                ><i class="bi bi-check2"></i></button>
                                                                <button class="delete_btn_act"
                                                                    onClick={() => updateRequest(eachItem.id, 2)}
                                                                ><i class="bi bi-x-lg"></i></button>
                                                            </span>
                                                            :
                                                            <p className={eachItem.status == 1 ? "text-success" : "text-danger"}>{eachItem.status == 1 ? "Approved" : "Declined"}</p>
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    ) : (
                                        <tr className="list_detail">
                                            <td colSpan='10'>No Data Found</td>
                                        </tr>
                                    )}
                                </table>
                            </div>
                        </div>
                    </div>

                        {pages.length > 1 &&
                                            <div>
                                                {pages.length > 1 && (
                                                    <Pagination
                                                        pages={pages}
                                                        currentPage={pageNumber}
                                                        onClickPageNumber={(page) => {
                                                            fetchRequests(page);  // Request the selected page
                                                            setPageNumber(page);
                    }}
                />
                                                )}
                    
                                            </div>
                                        }

                </Col>


            </Row>
        </FullLayout>
    );
};

export default KYCRequests;
